import jsPDF from "jspdf";
import { PDF_TRANSLATIONS } from "../../../locales/pdfTranslations";
import { ROBOTO_BASE64 } from "../../../assets/fonts/roboto";
import { BIG_LOGO_BASE64 } from "../../../assets/bigLogo";

export async function generateApplicationPdfBase64({
                                                       values,
                                                       user,
                                                       applicationId,
                                                       language = "en",
                                                       submissionDate = new Date(),
                                                       pdfType = "apply", // "apply" | "30years"
                                                       countries,
                                                       counties,
                                                       currencies
                                                   }) {
    const t = PDF_TRANSLATIONS[language] || PDF_TRANSLATIONS.en;

    const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
    });
    const findLabelById = (source, id) => {
        if (!source || !id) return "—";
        if (!Array.isArray(source)) {
            if (source.Id !== id) return "—";
            return language === "el"
                ? source.NameEL || source.NameEN || "—"
                : source.NameEN || source.NameEL || "—";
        }

        const item = source.find(
            (x) => x.Id === id || x.id === id
        );

        if (!item) return "—";

        return language === "el"
            ? item.NameEL || item.NameEN || "—"
            : item.NameEN || item.NameEL || "—";
    };



    const formatDate = (v) => {
        if (!v) return "—";
        const d = new Date(v);
        if (isNaN(d.getTime())) return "—";
        return d.toLocaleDateString(language);
    };


    doc.addFileToVFS("Roboto-Regular.ttf", ROBOTO_BASE64);
    doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
    doc.setFont("Roboto", "normal");

    let y = 40;


    if (BIG_LOGO_BASE64) {
        doc.addImage(BIG_LOGO_BASE64, "PNG", 20, 10, 82, 13);
    }


    doc.setFontSize(11);
    doc.text(`${t.applicationId}: ${applicationId}`, 20, y);
    y += 6;

    doc.text(
        `${t.submissionDate}: ${submissionDate.toLocaleDateString(language)}`,
        20,
        y
    );

    y += 10;

    doc.setFontSize(10);


    const line = (label, value) => {
        if (typeof label !== "string") {
            console.warn("PDF label missing:", label);
            return;
        }

        let safeValue = "—";

        if (value !== null && value !== undefined) {
            if (typeof value === "string") {
                safeValue = value;
            } else if (typeof value === "number") {
                safeValue = value.toString();
            } else if (value instanceof Date) {
                safeValue = value.toLocaleDateString(language);
            } else if (typeof value === "object") {
                safeValue =
                    value.label ||
                    value.name ||
                    value.title ||
                    value.code ||
                    JSON.stringify(value);
            } else {
                safeValue = String(value);
            }
        }

        doc.text(`${label}: ${safeValue}`, 20, y);
        y += 6;
    };


    line(t.organizationName, language === 'el'? values.orgName : values.orgName_en);
    line(t.tin, values.tin);

    if (pdfType === "30years") {
        if (t.registeredAsPer) line(t.registeredAsPer, values.orgRegisteredAsPer);
        if (t.dateEstablished) {
            line(t.dateEstablished, formatDate(values.orgDateEstablished));
        }

        if (t.fiscalSponsor) line(t.fiscalSponsor, values.orgFiscalSponsor);
    }


    line(
        t.address,
        `${values.address1}, ${values.zip}, ${values.city}, ${findLabelById(counties, values.state)}, ${findLabelById(countries, values.country)}`
    );



    line(t.contactDetails, `${values.email}, ${values.phone}`);
    line(t.website, values.website);


    y += 4;
    if (typeof t.orgInfo === "string") {
        doc.setFontSize(11);
        doc.text(t.orgInfo, 20, y);
        y += 6;
        doc.setFontSize(10);
        doc.text(values.historyMission || "", 20, y, { maxWidth: 170 });
        y += 10;
    }

    if (pdfType === "30years" && typeof t.orgMission === "string") {
        doc.setFontSize(11);
        doc.text(t.orgMission, 20, y);
        y += 6;
        doc.setFontSize(10);
        doc.text(values.historyMission || "", 20, y, { maxWidth: 170 });
        y += 10;
    }


    if (typeof t.requestDesc === "string") {
        doc.setFontSize(11);
        doc.text(t.requestDesc, 20, y);
        y += 6;
        doc.setFontSize(10);
        doc.text(values.requestDescription || "", 20, y, { maxWidth: 170 });
        y += 10;
    }

    line(t.amount, values.amount);
    line(t.currency, findLabelById(currencies, values.currency));


    doc.setFontSize(9);
    doc.text(`${t.page} 1 / 1`, 190, 290, { align: "right" });

    return doc.output("datauristring").split(",")[1];
}
